import { gql } from "@apollo/client";

export const insurancePackagesDetailedQuery = gql`
  query($rv: Int!, $rental_type: Int) {
    insurance_packages_detailed(
      rv: $rv,
      rental_type: $rental_type
    ) {
      result {
        success
        errors {
          code
          field
          section
          title
          message
        }
      }
      data {
        groups {
          header
          items {
            id
            tip
            name {
              id
              value
              style
            }
          }
        }
        plans {
          id
          name
          price
          isDefault
          promo {
            id
            value
            style
          }
          promoType
          items {
            id
            value {
              id
              value
              style
            }
          }
        }
      }
    }
  }
`;
